import { useEffect, useRef, useState, useContext } from "react";
import API from '@api/api'
import { Spin, message, Select, Popover } from "antd";
import styles from './index.module.scss'
import eventBus from "@utils/eventBus";
import QRCode from 'qrcode.react'
import Utils from '@utils/utils'
import { InfoCircleOutlined } from '@ant-design/icons'
import { AppContext } from '@utils/AppContext';

const Tips = (props) => {
    const {
        unit,
        powerAmount,
        isAutoRenew
    } = props

    return (
        <ul className={styles.Tips}>
            <li>支付完成后默认您同意
                {!isAutoRenew ?
                    <a style={{ color: '#006EFF' }} target='_blank' href="/会员条款.htm">《PSAI付费会员及自动续费服务协议》</a> :
                    <a style={{ color: '#006EFF' }} target='_blank' href="/会员条款.htm">《PhotoStudio会员服务条款》</a>}
            </li>
            <li>虚拟商品，支付后无法退还</li>
            <li>{unit == 'Month' ? '包月' : unit == 'Quarter' ? '包季' : '包年'}会员服务有效期为{unit == 'Month' ? '30' : unit == 'Quarter' ? '90' : '365'}天
                {!isAutoRenew ? '，到期后42元/月自动续订，可随时自行取消' : ''}
            </li>
            <li>会员订购当天可获得 <span>{powerAmount}</span> 虹豆，若您为其他套餐有效期内升级本套餐的，原套餐剩余虹豆合并计入本套餐，有效期以本套餐为准</li>
            <li>有效期内未用完的虹豆，如有续订自动转入下一周期，如未续订则在有效期到期时清空</li>
        </ul>
    )
}

const AlipayQrcode = (props) => {
    const alipayFrameRef = useRef()

    useEffect(() => {
        alipayFrameRef.current.contentWindow.document.write(props.url)
    }, [props.url])

    return (
        <div className={styles.PayContent} key={props.url}>
            <div className={styles.iframePlaceholderWrap}>
                <Spin wrapperClassName={styles.iframePlaceholderSpin} spinning>
                    <div className={`${styles.iframePlaceholder} ${styles.alipay}`}></div>
                </Spin>
            </div>
            <iframe ref={alipayFrameRef}
                className={styles.payFrame}
                style={{ display: 'block' }}
                // srcDoc={payUrl}
                width="200"
                height="200"
                marginWidth={0}
                marginHeight={0}
                frameBorder="0"
                border="0"
                scrolling="no"
            ></iframe>
        </div>
    )
}

const WechatQrcode = (props) => {
    return (
        <div className={styles.PayContent} key={props.url}>
            <QRCode
                id="qrcode"
                value={props.url}
                size={200}
                level="H"
                style={{ margin: 'auto' }}
                imageSettings={{
                    src: require('@assets/images/icon_wxpay@2x.png'),
                    width: 50,
                    height: 50,
                    excavate: true,
                }}
            />
        </div>
    )
}

// 支付宝连续包月
const AlipayQrcodeMonth = (props) => {
    return (
        <div className={styles.PayContent} key={props.url}>
            <QRCode
                id="qrcode"
                value={props.url}
                size={200}
                level="H"
                style={{ margin: 'auto' }}
                imageSettings={{
                    src: require('@assets/images/icon_alipay.png'),
                    width: 50,
                    height: 50,
                    excavate: true,
                }}
            />
        </div>
    )
}

const CouponSelect = (props) => {
    const [list, setList] = useState([])
    const [defaultValue, setDefaultValue] = useState()
    const [inited, setInited] = useState(false);
    const hasInitRunRef = useRef(false);

    const { payOrderInfo, globalOrgInfo, setRechargeModel, isAutoRenew, setIsAutoRenew } = useContext(AppContext);

    useEffect(() => {
        if (!props.payOrderInfo?.skuId) return;
        API.getCouponListForPay({
            type: 0,
            id: props.payOrderInfo?.skuId,
        })
            .then(res => {
                if (res?.code != 0) throw new Error(res.message)
                setList(res.data)
                if (res.data?.length > 1) {
                    setDefaultValue(res.data[0]?.bindingId)
                }
                postSubscribePlan(res.data[0]?.bindingId) // 首次请求
            })
            .catch(err => message.error(err.message))
            .finally(() => setInited(true))
    }, [props.payOrderInfo?.skuId])

    useEffect(() => {
        if (!inited || !props.payOrderInfo?.skuId) return;

        if (!hasInitRunRef.current) {
            hasInitRunRef.current = true;
            if (props.channel) {
                postSubscribePlan(defaultValue);
            }
            return;
        }

        postSubscribePlan(defaultValue);
    }, [props.channel, defaultValue, isAutoRenew]);


    const postSubscribePlan = (bindingId) => {
        if (props.payOrderInfo?.monthlySubscription && !isAutoRenew) {
            API.postSubscribePlanCycle({
                skuId: props.payOrderInfo?.skuId,
                channel: props.channel,
            }).then(res => {
                if (res?.code != 0) {
                    props.onClose()
                    throw new Error(res.message)
                } else {
                    props.getOrderRes(res.data)
                }
            }).catch(err => {
                message.error(err.message)
            })
        } else {
            API.postSubscribePlan({
                skuId: props.payOrderInfo?.skuId,
                orgId: props.payOrderInfo?.orgId,
                couponBindingId: bindingId,
                diyPower: props.payOrderInfo?.diyPower,
                diyMember: props.payOrderInfo?.diyMember,
                channel: props.channel,
            }).then(res => {
                if (res?.code != 0) {
                    props.onClose()
                    throw new Error(res.message)
                } else {
                    props.getOrderRes(res.data)
                }
            }).catch(err => {
                message.error(err.message)
            })
        }

    }

    const onChange = (value) => {
        setDefaultValue(value)
    }

    const labelRender = (item) => {
        if (!item.value) return <span className={`${styles.CouponSelected} ${styles.none}`}>{item.label}</span>
        return <span className={styles.CouponSelected}>{item.label}</span>
    }

    return (
        isAutoRenew && <div className={styles.CouponSelectWrap}>
            {
                inited &&
                <Select
                    defaultActiveFirstOption
                    defaultValue={defaultValue}
                    placeholder='暂无优惠券'
                    className={styles.CouponSelect}
                    popupClassName={styles.CouponSelectPopup}
                    fieldNames={{ label: 'name', value: 'bindingId' }}
                    options={list}
                    onChange={onChange}
                    labelRender={labelRender}
                />
            }
        </div>
    )
}



export default function Payment(props) {
    const isMounted = useRef(true)
    const refreshTimerRef = useRef(null)
    const [tradeId, setTradeId] = useState()
    const [loading, setLoading] = useState(false)
    const [channel, setChannel] = useState('alipay') // 支付渠道 alipay or wechat
    const [payUrl, setPayUrl] = useState() // 支付链接
    const [dealAmount, setDealAmount] = useState() // 支付金额
    const [unit, setUnit] = useState('Year') // 单位
    const [powerAmount, setPowerAmount] = useState(0) // 虹豆数
    const [subject, setSubject] = useState('')
    const { payOrderInfo, globalOrgInfo, setRechargeModel, isAutoRenew, setIsAutoRenew } = useContext(AppContext);

    useEffect(() => {
        return () => {
            isMounted.current = false
            if (refreshTimerRef.current) {
                clearTimeout(refreshTimerRef.current)
                refreshTimerRef.current = null
            }
        }
    }, [])

    const refreshAccountStateAfterPayment = () => {
        eventBus.emit('updatePower')
        eventBus.emit('updateUserInfo')
        eventBus.emit('getUserOrgInfo')
        eventBus.emit('updateOrderList')

        if (refreshTimerRef.current) {
            clearTimeout(refreshTimerRef.current)
        }

        refreshTimerRef.current = setTimeout(() => {
            if (!isMounted.current) return
            eventBus.emit('updatePower')
            eventBus.emit('updateUserInfo')
            eventBus.emit('getUserOrgInfo')
            eventBus.emit('updateOrderList')
            refreshTimerRef.current = null
        }, 1200)
    }

    const checkTradeStatus = (timerRef) => {
        const api = isAutoRenew ? API.paymentOrderStatus : API.cyclePayStatus
        const params = isAutoRenew ? { tradeList: [tradeId] } : { outAgreementNo: tradeId }
        api(params).then(res => {
            if (res.code != 0) return
            const item = isAutoRenew ? res.data[0] : res.data
            if (item.status === 'success') {
                message.success('支付成功')
                refreshAccountStateAfterPayment()
                if (!globalOrgInfo?.current?.id && payOrderInfo?.orgId) { // 个人版购买企业后要刷新页面
                    message.success('即将跳转企业账号')
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000)
                }
                props.onClose()
                setRechargeModel(false)
                props.onPayedCb?.()
                props.callbackClose?.()

                return
            } else if (item.status === 'closed') {
                console.log('订单关闭，刷新订单', item.tradeId)
                // message.success('订单已关闭')
                props.onClose()
                // props.onPayedCb && props.onPayedCb()
                return
            } else {
                // 设置新的定时器
                timerRef.current = setTimeout(() => {
                    if (isMounted.current) checkTradeStatus(timerRef)
                }, 600)
            }
        })
    }

    useEffect(() => {
        if (!tradeId) return

        const timerRef = { current: null }
        checkTradeStatus(timerRef)

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current)
                timerRef.current = null
            }
        }
    }, [tradeId])

    const getOrderRes = (data) => {
        setPayUrl(data?.payUrl)
        setDealAmount(data?.dealAmount)
        setSubject(data?.subject)
        setTradeId(data?.tradeId)
        setPowerAmount(data?.powerAmount)
        setUnit(data?.unit)
    }

    const QRcoreContent = () => {
        return (
            <img className={styles.qrcodeSales} src={Utils.qrcodeSales} alt="扫码联系我们" />
        )
    }


    return (
        <div className={styles.Container}>
            <p className={styles.Head}>开通 {subject} 包{unit == 'Year' ? '年' : '月'}会员</p>
            <p className={styles.Head2}>请扫码支付 <span>{dealAmount}</span> 元</p>
            <Spin spinning={loading}>
                <div className={styles.Content}>
                    <CouponSelect
                        skuId={props.skuId}
                        onClose={props.onClose}
                        diyPower={props.diyPower}
                        diyMember={props.diyMember}
                        channel={channel}
                        getOrderRes={getOrderRes}
                        payOrderInfo={payOrderInfo}
                    />
                    <div className={styles.Qrcode}>
                        {
                            payUrl &&
                            <>
                                {
                                    !isAutoRenew ? <AlipayQrcodeMonth url={payUrl} /> :
                                        channel == 'alipay' ? <AlipayQrcode url={payUrl} /> :
                                            <WechatQrcode url={payUrl} />
                                }
                            </>
                        }
                    </div>
                    {
                        isAutoRenew && <div className={styles.ChannelBtn}>
                            <div
                                className={channel == 'alipay' ? styles.Active : ''}
                                onClick={() => { setPayUrl(''); setChannel('alipay') }}>
                                <img src={require('@assets/images/icon_alipay.png')} />支付宝</div>
                            <div
                                className={channel == 'wechat' ? styles.Active : ''}
                                onClick={() => { setPayUrl(''); setChannel('wechat') }}>
                                <img src={require('@assets/images/icon_wxpay.png')} />微信</div>
                        </div>
                    }

                    <div className={styles.bottomQrcode}>
                        <Popover placement="bottom" content={QRcoreContent}>
                            添加客服可开发票 <InfoCircleOutlined className={styles.infoIcon} />
                        </Popover>
                    </div>
                    <Tips
                        unit={unit}
                        powerAmount={powerAmount}
                        paymentLevel={props.paymentLevel}
                        isAutoRenew={isAutoRenew}
                    />
                </div>
            </Spin>
        </div>
    )
}
